import {
	fetchSpendCostsByMonthStart,
	fetchSpendCostsByMonthSuccess,
	fetchSpendCostsByMonthFailure,
	fetchSpendCostsByProblemTypeStart,
	fetchSpendCostsByProblemTypeSuccess,
	fetchSpendCostsByProblemTypeFailure,
	fetchSpendCostsByVendorStart,
	fetchSpendCostsByVendorSuccess,
	fetchSpendCostsByVendorFailure,
	fetchSpendCostsByLocationStart,
	fetchSpendCostsByLocationSuccess,
	fetchSpendCostsByLocationFailure,
} from '../actions/spend_analytics_actions';
import { makeFetchSpendData } from './spend_analytics_thunks';

// Per-source spend reporting (OPE-4875): rolls up invoice + spot purchase + tool-use + parts spend.
// Same query-building/dispatch as the invoice analytics thunks, pointed at the /spend namespace.
const spendApiUrl = (userType) => `/api/v1/${userType}/spend/spend_reportings`;
const fetchSpendCostsData = makeFetchSpendData(spendApiUrl);

export const fetchSpendCostsByMonth = fetchSpendCostsData(
	fetchSpendCostsByMonthStart,
	fetchSpendCostsByMonthSuccess,
	fetchSpendCostsByMonthFailure,
	'spend_monthly_cost'
);

export const fetchSpendCostsByProblemTypeWithChildren = fetchSpendCostsData(
	fetchSpendCostsByProblemTypeStart,
	fetchSpendCostsByProblemTypeSuccess,
	fetchSpendCostsByProblemTypeFailure,
	'spend_costs_by_problem_type_with_children'
);

export const fetchSpendCostsByVendor = fetchSpendCostsData(
	fetchSpendCostsByVendorStart,
	fetchSpendCostsByVendorSuccess,
	fetchSpendCostsByVendorFailure,
	'spend_costs_by_supplier_facility'
);

export const fetchSpendCostsByLocationWithRegions = fetchSpendCostsData(
	fetchSpendCostsByLocationStart,
	fetchSpendCostsByLocationSuccess,
	fetchSpendCostsByLocationFailure,
	'spend_costs_by_location_with_regions'
);
